import { linko } from "@shared/linko";

export interface RegistrationTrackingQueryBody {
  organizationId: string;
  dateFrom: string;
  dateTo: string;
  opportunityId?: string;
  categoryIds?: string[];
  subCategoryId?: string;
  teamIds?: string[];
  populationIds?: string[];
  partnerOrganizationIds?: string[];
  page?: number;
  pageSize?: number;
  registrantType?: "both" | "individual" | "group";
}

export interface OpportunityRegistrationRow {
  opportunityId: string;
  title: string;
  amount: number;
  volunteerMode: string;
  isLongTerm: boolean;
  startDate: string | null;
  partnerOrganizationId: string | null;
  partnerOrganizationName: string | null;
  approvedTotal: number;
  pendingTotal: number;
  registrationsInRange: number;
  interestedInRange: number;
  fillRatePercent: number | null;
}

export interface RegistrationTrackingDailyRow {
  date: string;
  approvedRegistrations: number;
  interestedRegistrations: number;
}

export interface RegistrationTrackingResult {
  dateFrom: string;
  dateTo: string;
  opportunities: OpportunityRegistrationRow[];
  totalCount?: number;
  registrationsInRangeTotal?: number;
  daily?: RegistrationTrackingDailyRow[];
}

/** Rows per request for list view - keep small; each page re-aggregates scoped opps. */
export const REGISTRATION_TRACKING_PAGE_SIZE = 25;

type StatisticsRegistrationQueries = {
  getRegistrationTracking: (
    body: RegistrationTrackingQueryBody,
  ) => Promise<{ data: RegistrationTrackingResult }>;
};

/**
 * One request = one page. Do not loop pages here: each call re-aggregates
 * participants for the full scoped set, so multi-page fetch freezes the app.
 */
export async function fetchRegistrationTracking(
  body: RegistrationTrackingQueryBody,
): Promise<RegistrationTrackingResult> {
  const queries = linko.statistics
    .queries as unknown as StatisticsRegistrationQueries;
  const { data } = await queries.getRegistrationTracking({
    ...body,
    page: body.page ?? 1,
    pageSize: body.pageSize ?? REGISTRATION_TRACKING_PAGE_SIZE,
  });
  return data;
}
